import React, { useState, useEffect } from 'react';
import {
  IonPage,
  IonContent,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonIcon
} from '@ionic/react';
import { barbellOutline, restaurantOutline } from 'ionicons/icons';
import ExercisePlan from './ExercisePlan';
import DietGenerator from './DietGenerator';
import './LifestyleTools.css';

const LifestyleTools = ({ member_id, user_id, auth_token }) => {
  const [activeTab, setActiveTab] = useState('exercise');

  // Message-event based authentication handling (iframe mode)
  const [effectiveMemberId, setEffectiveMemberId] = useState(() => member_id || localStorage.getItem('member_id') || '');
  const [effectiveAuthToken, setEffectiveAuthToken] = useState(() => auth_token || localStorage.getItem('auth_token') || '');
  
  useEffect(() => {
    const allowedOrigins = [
      'https://www.infinity-mc-hms.com',
      'https://infinity-mc-healthplan-edit-dot-infinity-medical-concier-724b0.lm.r.appspot.com',
      'http://localhost:3000',
      'http://localhost:5000',
      'https://localhost:3000',
      'https://localhost:5000'
    ];
    
    const handleMessage = (event) => {
      // Ignore MetaMask, webpack, etc. messages
      if (event.data?.target === 'metamask-contentscript' || 
          event.data?.target === 'metamask-inpage' ||
          event.data?.type === 'webpackWarnings') {
        return;
      }
      if (!allowedOrigins.includes(event.origin)) return;
      if (event.data && event.data.type === 'AUTH_DATA') {
        const { member_id: receivedMemberId, auth_token: receivedAuthToken } = event.data;
        if (receivedMemberId && receivedAuthToken) {
          localStorage.setItem('member_id', receivedMemberId);
          localStorage.setItem('auth_token', receivedAuthToken);
          setEffectiveMemberId(receivedMemberId);
          setEffectiveAuthToken(receivedAuthToken);
          console.log('Auth data received:', { 
            member_id: receivedMemberId, 
            auth_token: receivedAuthToken ? '***' : undefined
          });
        } else {
          // Optionally handle error state here if desired
        }
      }
    };

    window.addEventListener('message', handleMessage);
    // If not received, request auth from parent
    if (!effectiveMemberId || !effectiveAuthToken) {
      allowedOrigins.forEach(origin => {
        try {
          window.parent.postMessage({ type: 'REQUEST_AUTH' }, origin);
        } catch (error) {}
      });
    }
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [effectiveMemberId, effectiveAuthToken]);

  return (
    <IonPage>
      <IonContent className="lifestyle-tools-content">
        <div className="lifestyle-tools-container">
          {/* Tab Navigation */}
          <div className="tab-navigation">
            <IonSegment
              value={activeTab}
              onIonChange={(e) => setActiveTab(e.detail.value)}
              className="lifestyle-tabs"
            >
              <IonSegmentButton value="exercise">
                <IonIcon icon={barbellOutline} />
                <IonLabel>Exercise Plan Generator</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="diet">
                <IonIcon icon={restaurantOutline} />
                <IonLabel>Diet Generator</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === 'exercise' && (
              <ExercisePlan
                member_id={effectiveMemberId}
                user_id={user_id}
                auth_token={effectiveAuthToken}
                noPageWrapper={true}
              />
            )}
            {activeTab === 'diet' && (
              <DietGenerator
                member_id={effectiveMemberId}
                user_id={user_id}
                auth_token={effectiveAuthToken}
                noPageWrapper={true}
              />
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LifestyleTools;

